module.exports = __webpack_public_path__ + "static/media/comentar.f78b2cce.svg";